import React, { useState, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { useEffect } from 'react'

const useOutsideClick = (ref, callback) => {
  const handleClick = e => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)
    document.addEventListener('touch', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('touch', handleClick)
    }
  })
}

const useStyles = makeStyles(theme => ({
  label: {
    display: 'block'
  },
  listbox: {
    width: 'calc(100% - 20px)',
    margin: '15px 0px',
    padding: '10px 0',
    // zIndex: 1,
    position: 'absolute',
    listStyle: 'none',
    backgroundColor: 'white',
    overflow: 'unset',
    maxHeight: 500,
    border: '1px solid #668c98',
    borderRadius: 2,
    [theme.breakpoints.up('md')]: {
      width: 110
    },
    '& li': {
      cursor: 'pointer'
    },
    '& li:active': {
      backgroundColor: '#eefbfc'
    },
    '& li:hover': {
      backgroundColor: '#eefbfc'
    },
    '&::before': {
      content: "''",
      display: 'block',
      width: '14px',
      height: '14px',
      position: 'absolute',
      border: 'solid #668c98',
      borderWidth: '1px 0 0 1px',
      backgroundColor: '#fff',
      transform: 'rotate(45deg)',
      top: '-8px',
      left: '20px'
    }
  },
  listItem: {
    padding: '6px 16px 5px'
  },
  listItemHightLight: {
    backgroundColor: '#eefbfc'
  },
  itemGroupTag: {
    margin: '6px 16px 5px',
    fontWeight: 600
  },
  divider: {
    margin: '10px 10px'
  },
  errorContainer: {
    margin: '0 10px 10px',
    border: '1px solid #a10000',
    padding: 10,
    background: '#f1d8d6',
    color: '#002f3d',
    fontSize: 14,
    lineHeight: 1.2,
    borderRadius: 2
  },
  errorIcon: {
    position: 'absolute',
    top: 15,
    left: 20,
    fontSize: 16,
    padding: 1,
    border: '2px solid #a10000',
    borderRadius: '50%',
    color: '#a10000',
    lineHeight: '1',
    '&::before': {
      fontFamily: 'nch-icons',
      verticalAlign: 'middle',
      content: '""'
    }
  },
  errorMessage: {
    margin: '0 0 0 32px',
    color: '#002f3d',
    fontSize: '16px',
    fontWeight: 500
  },
  innerOverFlow: {
    overflow: 'auto',
    maxHeight: 210
  }
}))

const TimePickerBookameeting = ({
  inputProps,
  options,
  placeholder,
  value: selectValue,
  onChange: setSelectValue,
  valuePostfix = ''
}) => {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => setIsOpen(!isOpen)

  TimePickerBookameeting.handleClickOutside = () => {
    setIsOpen(false)
  }

  const ref = useRef()

  useOutsideClick(ref, () => {
    setIsOpen(false)
  })

  return (
    <div ref={ref}>
      <input
        readOnly
        value={selectValue && selectValue + valuePostfix}
        placeholder={placeholder}
        {...inputProps}
        onClick={toggle}
      />
      {isOpen && (
        <ul className={classes.listbox}>
          <div className={classes.innerOverFlow}>
            {options.map(({ label, value }) => (
              <li
                key={value}
                className={clsx(classes.listItem, {
                  [classes.listItemHightLight]: value === selectValue
                })}
                onClick={() => {
                  setSelectValue(value)
                  setIsOpen(false)
                }}>
                {label}
              </li>
            ))}
          </div>
        </ul>
      )}
    </div>
  )
}

export default TimePickerBookameeting
